import { ProjectDto } from '@/core';
import { TableTypesEnum } from '../hooks';

export const validateTablesTab = (projectData: ProjectDto) =>
  !!projectData.tables.filter((table) => table.type === TableTypesEnum.Main).length &&
  !projectData.tables.some((table) => !table.columns.length);
